export default __webpack_public_path__ + "static/media/5453.e2046961.webp";